<mat-expansion-panel
  class="shape-list-group"
  togglePosition="before"
  [expanded]="isPanelExpanded$ | async"
  (mousedown)="modifyShapeSelection($event)"
>
  <mat-expansion-panel-header
    collapsedHeight="42px"
    class="shape-list-group-header subtitle-03"
  >
    <mat-panel-title>
      <span class="material-symbols-outlined icon">folder</span>
      <div class="shape-list-item-text">
        {{ groupStore('type').$ | async }}
      </div>
    </mat-panel-title>
    <mat-panel-description>
      <a (click)="ungroup($event)" *ngIf="(readOnly$ | async) !== true">
        <mat-icon class="material-symbols-outlined">link_off</mat-icon>
      </a>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <div cdkDropList (cdkDropListDropped)="reorder($event)">
    <h3-shape-list-shape
      *ngFor="let shapeStore of shapeStores$ | async"
      class="list-group-item"
      cdkDrag
      cdkDragLockAxis="y"
      (cdkDragStarted)="dragStarted(shapeStore)"
      [cdkDragData]="shapeStore"
      [cdkDragDisabled]="readOnly$ | async"
      [shapeIndex]="shapeStore.state().index"
      [hoverButtonTemplate]="hoverButtonTemplate"
      [staticButtonTemplate]="staticButtonTemplate"
      [memberOfGroup]="true"
      (newlySelected)="newlySelected.emit()"
    >
    </h3-shape-list-shape>
  </div>
</mat-expansion-panel>
